import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { getAssociateData, isAuthenticated } from '../services/otpAuthService';
import { studioDelDipendenteNonInRegola } from '../services/fineSessioneDipendente';
import { CodiceSezione, eDipendente, sezioneVisibile } from '../utils/sezioniDipendente';

/**
 * Guardia di una sezione dell'area riservata (spec dipendenti §6.2): al dipendente senza la
 * sezione abilitata la route rimanda alla dashboard, senza messaggi «non autorizzato».
 * Il titolare passa sempre. Senza `children` fa da route di struttura (`<Outlet />`), così in
 * App.tsx avvolge un gruppo intero di route.
 * Studio non in regola (403 `STUDIO_NON_IN_REGOLA`, Ruling R16): al dipendente tutte le sezioni sono
 * chiuse finché `/auth/me` non torna valida; la dashboard mostra l'avviso.
 */
const RichiedeSezione: React.FC<{ codice: CodiceSezione; soloConSessione?: boolean; children?: React.ReactNode }> = ({
  codice,
  soloConSessione = false,
  children,
}) => {
  // `soloConSessione` (guida formalità, aperta anche allo staff con formalita.admin_access): il controllo
  // vale solo con una sessione associato aperta, così dati del dipendente rimasti nel browser non rimandano lo staff
  if (soloConSessione && !isAuthenticated()) return <>{children ?? <Outlet />}</>;
  const dati = getAssociateData();
  if (!sezioneVisibile(dati, codice) || (eDipendente(dati) && studioDelDipendenteNonInRegola())) {
    return <Navigate to="/area-riservata" replace />;
  }
  return <>{children ?? <Outlet />}</>;
};

/** Parti riservate al titolare (Community v2): il dipendente torna sempre alla dashboard. */
export const SoloTitolare: React.FC<{ children?: React.ReactNode }> = ({ children }) => {
  if (eDipendente(getAssociateData())) {
    return <Navigate to="/area-riservata" replace />;
  }
  return <>{children ?? <Outlet />}</>;
};

export default RichiedeSezione;
